import React, { useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';

import useWindowSize from '../../utils/useWindowSize';
import { AccountLight, AccountGreen } from '../../Assets';
import { Button } from '../../Atoms';
import {
  getInvites,
  resendInvite,
  reset,
} from '../../redux/actions/ManagerAction';
import { connect } from 'react-redux';
import useToaster from '../Toaster/useToaster';

const TeamMemberList = ({
  getAllInvites,
  invites: { list },
  resendInviteDetails: { loading: resendLoading, error, success },
  resendInvite,
  reset,
}) => {
  const { width } = useWindowSize();
  const { toast } = useToaster();
  const history = useHistory();
  const lastLocation = useLastLocation();
  const [currentToken, setCurrentToken] = useState('');
  const classes = classNames('member-table', {
    'table-responsive': width < 678,
  });

  useEffect(() => {
    getAllInvites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success) {
      reset('resendInvite');
      toast({
        text: 'Invitation Resend successfully',
      });
    }

    if (error) {
      toast({
        text: error,
        type: 'error',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleClick = (e) => {
    const token = e.target.dataset.value;
    const host = window.location.origin;
    setCurrentToken(token);
    resendInvite({ token: token, invitation_url: `${host}/welcome` });
  };

  const handleContinue = () => {
    const path =
      lastLocation && ['/invite', '/info'].includes(lastLocation.pathname)
        ? '/complete'
        : '/';
    history.push(path);
  };

  return (
    <div className="team-member-list">
      <div className="heading">Team Members</div>
      <div className="list-wrapper">
        {!list.length ? (
          <div className="no-data">
            No team members have been added to your team
          </div>
        ) : (
          <div className="table-wrapper">
            <Table className={classes} borderless>
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {list.map((detail, index) => (
                  <tr key={index} className="data-row">
                    <td>
                      {detail.is_accepted ? <AccountGreen /> : <AccountLight />}
                    </td>
                    <td>{`${detail.first_name} ${detail.last_name}`}</td>
                    <td>{detail.email}</td>
                    <td>{detail.role}</td>
                    <td>
                      {!detail.is_accepted && (
                        <Button
                          size="md"
                          color="white"
                          data-value={detail.token}
                          onClick={handleClick}
                          loading={
                            resendLoading && currentToken === detail.token
                          }
                        >
                          Resend Invite
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="total-banner mb-3 mb-md-0">
              <span>{list.length}</span>Team Members Invited
            </div>
            <div className="action-wrapper">
              <Button size="lg" color="blue" onClick={handleContinue}>
                Continue
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  invites: state.manager.invites,
  resendInviteDetails: state.manager.resendInvite,
});

const mapDispatchToProps = (dispatch) => ({
  getAllInvites: () => {
    dispatch(getInvites());
  },
  resendInvite: (payload) => {
    dispatch(resendInvite(payload));
  },
  reset: (block) => {
    dispatch(reset(block));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamMemberList);
